class SizeGuide {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener("click", (e) => {

      const action = e.target.closest("[on\\:click]")?.getAttribute("on:click");

      if (action === "/showSizeGuide") this.open(e.target);
      if (action === "/closeSizeGuide") this.close(e.target);
      // TAB SWITCH
      if (e.target.matches(".size-guide-tabs .tab")) {
        this.switchTab(e.target);
      }
    });
  }

  open(trigger) {
    const wrapper = trigger.closest(".variant-picker") ?? trigger.closest(".bundle-variant-picker");
    const dialog = wrapper?.querySelector(".size-guide-dialog");
    dialog?.showModal();
  }

  close(trigger) {
    const dialog = trigger.closest(".size-guide-dialog");
    dialog?.close();
  }

  switchTab(tab) {
    const container = tab.closest(".size-guide-wrapper");

    container.querySelectorAll(".tab").forEach(t => t.classList.remove("active"));
    container.querySelectorAll(".tab-content").forEach(c => c.classList.remove("active"));

    tab.classList.add("active");

    const target = tab.dataset.tab;
    container.querySelector("#" + target).classList.add("active");
  }
}

new SizeGuide();